import { SelectField, useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getOptions } from './get_options';
import { getSummary } from './get_summary';
const bufferLabelCss = "bghcwi4";
const BufferLabel = forwardRef((props, ref) => {
  const size = 'small';
  const color = 'muted';
  return <BodyText ref={ref} {...props} size={size} color={color} className={classNames(bufferLabelCss, props.className)} />;
});
const BuffersLocked = () => {
  const {
    values: {
      beforeBuffer,
      afterBuffer
    }
  } = useFormContext();
  return getSummary(beforeBuffer, afterBuffer);
};
const BufferFields = () => {
  const bufferOptions = getOptions();
  return <>
      <BufferLabel id="before_buffer_label">
        {I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.buffer.before_label')}
      </BufferLabel>
      <SelectField options={bufferOptions} name="beforeBuffer" aria-labelledby="before_buffer_label" />
      <BufferLabel id="after_buffer_label">
        {I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.buffer.after_label')}
      </BufferLabel>
      <SelectField options={bufferOptions} name="afterBuffer" aria-labelledby="after_buffer_label" />
    </>;
};
export const Buffers = ({
  isLocked,
  ...props
}) => !isLocked ? <BufferFields {...props} /> : <BuffersLocked {...props} />;

require("./buffers.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./buffers.js");